// src/i18n.js
import { createI18n } from 'vue-i18n'

// importa os JSON diretamente (sem loaders)
import pt from './locales/pt.json'
import en from './locales/en.json'
import it from './locales/it.json'

const i18n = createI18n({
  legacy: false, // API compatível com Vue 3 (Composition/Composition-like)
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: { pt, en, it },
})

export default i18n
